import type { Menu, MenusEdge } from '@@partner:types:app'
import type {
  CommonPager,
  NestedFilter,
  CommonSort
} from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

export interface AllMenusQuery {
  allMenus: MenusEdge
}

export interface AllMenusQueryVariables {
  filter?: NestedFilter
  sort?: CommonSort
  pager: CommonPager
}

export const GQL_QUERY_ALL_MENUS = gql`
  query (
    $filter: NestedFilterInput
    $pager: CommonPagerInput
    $sort: CommonSortInput
  ) {
    allMenus (
      filter: $filter
      sort: $sort
      pager: $pager
    ) {
      edges {
        id
        name
        code
        type
        is_active
        created_at
        updated_at
        menuItemsCount
      }
      pageInfo {
        page
        perPage
        lastPage
        next
        total
      }
    }
  }
`

export const useFetchAllMenus = (variables: AllMenusQueryVariables) =>
  useQuery<AllMenusQuery, AllMenusQueryVariables>(GQL_QUERY_ALL_MENUS, {
    variables,
    fetchPolicy: 'cache-and-network'
  })
